import { useState } from "react";
import { Input } from "./ui/input";

import { PlusIcon, X } from "lucide-react";
import { Badge } from "./ui/badge";
import { Button } from "./ui/button";

export function TagsInput({
  setTags,
  tags,
  id,
}: {
  id?: string;
  tags: string[];
  setTags: (tags: string[]) => void;
}) {
  const [text, setText] = useState("");
  const addTag = () => {
    setTags([...tags, text]);
    setText("");
  };
  const removeTag = (i: number) => {
    setTags(tags.filter((_, index) => index !== i));
  };

  return (
    <div className="grid gap-2 w-full">
      <div className="flex items-center gap-1">
        <Input
          id={id}
          value={text}
          onChange={(ev) => {
            setText(ev.target.value);
          }}
        />
        <Button disabled={!text} onClick={addTag} type="button">
          <PlusIcon />
        </Button>
      </div>
      {tags.length ? (
        <div className="flex gap-1 flex-wrap">
          {tags.map((tag, i) => (
            <Badge>
              {tag}{" "}
              <button
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    removeTag(i);
                  }
                }}
                onMouseDown={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                }}
                onClick={() => removeTag(i)}
                className="ml-1 ring-offset-background rounded-full outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2"
              >
                <X className="h-3 w-3 text-background" />
              </button>
            </Badge>
          ))}
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}
